"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mnemonicSchema = exports.ethUnitsSchema = exports.chainIdSchema = exports.keccak256HashSchema = exports.addressSchema = exports.hexSchema = void 0;
const promise_utils_1 = require("@api3/promise-utils");
const ethers_1 = require("ethers");
const zod_1 = require("zod");
exports.hexSchema = zod_1.z.string().regex(/^0x[\dA-Fa-f]+$/, 'Must be a valid hex string');
exports.addressSchema = zod_1.z.string().transform((value, ctx) => {
    const goParseAddress = (0, promise_utils_1.goSync)(() => ethers_1.ethers.utils.getAddress(value));
    if (!goParseAddress.success) {
        ctx.addIssue({ code: zod_1.z.ZodIssueCode.custom, message: 'Invalid EVM address' });
        return zod_1.z.NEVER;
    }
    return goParseAddress.data;
});
exports.keccak256HashSchema = zod_1.z
    .string()
    .regex(/^0x[\dA-Fa-f]{64}$/, 'Must be a valid EVM keccak256 hash')
    .transform((val) => val);
exports.chainIdSchema = zod_1.z
    .string()
    .regex(/^\d+$/, 'Must be a valid chain ID')
    .refine((chainId) => Number(chainId) > 0, 'Chain ID must be greater than 0');
exports.ethUnitsSchema = zod_1.z.union([
    zod_1.z.literal('wei'),
    zod_1.z.literal('kwei'),
    zod_1.z.literal('mwei'),
    zod_1.z.literal('gwei'),
    zod_1.z.literal('szabo'),
    zod_1.z.literal('finney'),
    zod_1.z.literal('ether'),
]);
exports.mnemonicSchema = zod_1.z
    .string()
    .refine((mnemonic) => ethers_1.ethers.utils.isValidMnemonic(mnemonic), 'Invalid mnemonic');
//# sourceMappingURL=schema.js.map